import axios from 'axios'
import { Message } from 'element-ui'

/**
 * 后端基础地址。
 * 生产环境走域名 lyqanddyl.com（nginx 分流：主后台业务→3000，小程序接口→3001）。
 */
const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://lyqanddyl.com'
  : ''

/**
 * Axios 实例，统一配置 baseURL 和超时时间。
 */
const service = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
})

/**
 * 请求拦截器 — 自动注入 token。
 */
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器 — 统一处理响应码和错误提示。
 *
 * 后端统一响应格式：{ code: 0, message: 'success', data: { ... } }
 * - code=0 或 code=200 视为成功，直接返回 data 字段
 * - 其他 code 视为业务错误，自动弹出错误提示并 reject
 * - 网络异常也弹出提示并 reject
 */
service.interceptors.response.use(
  (response) => {
    const res = response.data

    // 兼容旧格式 success=true 和新格式 code=0/200
    if (res && (res.code === 0 || res.code === 200 || res.success === true)) {
      return res.data
    }

    const errorMessage = res?.message || '请求失败'
    Message.error(errorMessage)
    return Promise.reject(new Error(errorMessage))
  },
  (error) => {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      '网络异常，请稍后重试'
    Message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default service
